/* =========================================================
   TIJARAH-STYLE PRODUCT PAGE — behaviour
   No WhatsApp / chat-widget code lives here on purpose.
   ========================================================= */
(function () {
  'use strict';

  document.querySelectorAll('.tj-product-page').forEach(initProductPage);

  function initProductPage(root) {
    initGallery(root);
    initSwatches(root);
    initQuantityBreaks(root);
    initBuyNow(root);
    initTimeline(root);
    initStickyBar(root);
    initTestimonialCarousel(root);
  }

  /* ---------------- GALLERY ---------------- */
  function initGallery(root) {
    const thumbs = root.querySelectorAll('.tj-thumb');
    const dots = root.querySelectorAll('.tj-media-dot');
    const slides = root.querySelectorAll('.tj-media-slide');

    function showMedia(targetId) {
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.targetMedia === targetId));
      dots.forEach((d) => d.classList.toggle('is-active', d.dataset.targetMedia === targetId));
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === targetId));
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.targetMedia));
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => showMedia(dot.dataset.targetMedia));
    });

    const track = root.querySelector('[data-thumbs-track]');
    const prevBtn = root.querySelector('[data-thumb-prev]');
    const nextBtn = root.querySelector('[data-thumb-next]');
    if (track && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => track.scrollBy({ left: -160, behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => track.scrollBy({ left: 160, behavior: 'smooth' }));
    }

    // ---- Swipe left/right on the main image to change slides ----
    // Only considers currently-visible slides, so swiping respects
    // whatever color filter is active.
    const mainMedia = root.querySelector('.tj-media-main');
    if (mainMedia) {
      let touchStartX = 0;
      let touchStartY = 0;

      mainMedia.addEventListener(
        'touchstart',
        (e) => {
          const t = e.touches[0];
          touchStartX = t.clientX;
          touchStartY = t.clientY;
        },
        { passive: true }
      );

      mainMedia.addEventListener(
        'touchend',
        (e) => {
          const t = e.changedTouches[0];
          const dx = t.clientX - touchStartX;
          const dy = t.clientY - touchStartY;

          const SWIPE_THRESHOLD = 40;
          // Ignore mostly-vertical drags so page scrolling still works.
          if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;

          const visibleSlides = Array.from(slides).filter((s) => s.style.display !== 'none');
          if (visibleSlides.length < 2) return;

          const currentIndex = visibleSlides.findIndex((s) => s.classList.contains('is-active'));
          if (currentIndex === -1) return;

          const nextIndex =
            dx < 0
              ? (currentIndex + 1) % visibleSlides.length // swipe left -> next
              : (currentIndex - 1 + visibleSlides.length) % visibleSlides.length; // swipe right -> prev

          showMedia(visibleSlides[nextIndex].dataset.mediaId);
        },
        { passive: true }
      );
    }

    // ---- Filter gallery to the selected color ----
    // Elements tagged data-color="<value>" (set via image ALT text
    // convention in the theme) belong to that color; elements with an
    // empty data-color are "shared" and stay visible for every color.
    function filterByColor(colorValue, fallbackMediaId) {
      const taggedForColor = Array.from(slides).filter((s) => s.dataset.color === colorValue);

      if (taggedForColor.length > 0) {
        // Show only this color's images + untagged/shared images.
        [thumbs, dots, slides].forEach((group) => {
          group.forEach((el) => {
            const belongs = el.dataset.color === colorValue || el.dataset.color === '';
            el.style.display = belongs ? '' : 'none';
          });
        });
        showMedia(taggedForColor[0].dataset.mediaId);
      } else if (fallbackMediaId) {
        // No alt-tagged images for this color — fall back to the
        // variant's assigned Featured Image (set in Shopify admin
        // under variant > image) and leave the rest of the gallery as-is.
        [thumbs, dots, slides].forEach((group) => group.forEach((el) => { el.style.display = ''; }));
        showMedia(String(fallbackMediaId));
      } else {
        // Nothing to filter on — show everything.
        [thumbs, dots, slides].forEach((group) => group.forEach((el) => { el.style.display = ''; }));
      }
    }

    root.addEventListener('tj:color-change', (e) => {
      filterByColor(e.detail.colorValue, e.detail.fallbackMediaId);
    });
  }

  /* ---------------- OPTION SWATCHES -> VARIANT ---------------- */
  function initSwatches(root) {
    const form = root.querySelector('#tj-product-form, [id^="tj-product-form"]');
    if (!form) return;

    const selected = {};
    root.querySelectorAll('.tj-swatches').forEach((group) => {
      const idx = group.dataset.optionIndex;
      const activeBtn = group.querySelector('.tj-swatch.is-selected');
      if (activeBtn) selected[idx] = activeBtn.dataset.value;

      group.addEventListener('click', (e) => {
        const btn = e.target.closest('.tj-swatch');
        if (!btn) return;
        group.querySelectorAll('.tj-swatch').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selected[idx] = btn.dataset.value;

        const label = btn.closest('.tj-option-block').querySelector('.tj-option-value');
        if (label) label.textContent = btn.dataset.value;

        const matchedVariant = updateVariant(root, selected);

        const optionNameDown = (group.dataset.optionName || '').toLowerCase();
        // Treat it as the "color" group if it's literally named that,
        // OR if it's simply the first swatch group on the page (index 0) —
        // covers products where the option isn't named "Color"/"Colour".
        const isColorGroup =
          optionNameDown === 'color' || optionNameDown === 'colour' || idx === '0';
        if (isColorGroup) {
          let fallbackMediaId = null;
          if (matchedVariant) {
            const mapEl = root.querySelector('[data-variant-featured-media]');
            if (mapEl) {
              try {
                const map = JSON.parse(mapEl.textContent);
                fallbackMediaId = map[matchedVariant.id] || null;
              } catch (err) { /* ignore malformed map */ }
            }
          }
          root.dispatchEvent(
            new CustomEvent('tj:color-change', {
              detail: { colorValue: btn.dataset.value, fallbackMediaId },
            })
          );
        }
      });
    });
  }

  // Matches selected option values against product.variants (injected via JSON below)
  // Returns the matched variant object (or undefined) so callers can react further.
  function updateVariant(root, selectedMap) {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return undefined; // falls back to native form submission w/ default variant
    let productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return undefined;
    }

    const optionValues = Object.keys(selectedMap)
      .sort((a, b) => a - b)
      .map((k) => selectedMap[k]);

    const match = productData.variants.find((v) =>
      v.options.every((opt, i) => opt === optionValues[i])
    );
    if (!match) return undefined;

    const variantInput = root.querySelector('[id^="tj-variant-id-"]');
    if (variantInput) variantInput.value = match.id;

    const priceEl = root.querySelector('.tj-price');
    const compareEl = root.querySelector('.tj-compare-price');
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    const addBtn = root.querySelector('.tj-btn-add-cart');
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }

    return match;
  }

  function formatMoney(cents) {
    // Adjust to match your store's currency formatting / Shopify money filter.
    return (cents / 100).toFixed(2);
  }

  /* ---------------- QUANTITY BREAKS (Buy 1 / 2 / 3) ---------------- */
  function initQuantityBreaks(root) {
    const radios = root.querySelectorAll('.tj-qty-breaks input[type="radio"]');
    if (!radios.length) return;

    const qtyInput = root.querySelector('[id^="tj-qty-input-"]');

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        root.querySelectorAll('.tj-qty-option').forEach((label) =>
          label.classList.toggle('is-checked', label.contains(radio) && radio.checked)
        );
        if (qtyInput) qtyInput.value = radio.value;
      });
    });

    // "#1 [Color ▾]" dropdown on a quantity-break tier drives the same
    // variant-matching logic as clicking a color swatch.
    root.querySelectorAll('[data-qty-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const swatchGroup = root.querySelector('.tj-swatches[data-option-index="0"]');
        if (!swatchGroup) return;
        const match = swatchGroup.querySelector(`.tj-swatch[data-value="${CSS.escape(select.value)}"]`);
        if (match) match.click(); // reuses the existing swatch click handler
      });
    });
  }

  /* ---------------- TESTIMONIAL CAROUSEL ---------------- */
  function initTestimonialCarousel(root) {
    const carousel = root.querySelector('[data-testimonial-carousel]');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.tj-testimonial-slide');
    const dots = carousel.querySelectorAll('.tj-testimonial-dot');
    if (slides.length < 2) return; // nothing to page through

    let current = 0;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // auto-advance every 5s, pause on hover
    let timer = setInterval(() => goTo(current + 1), 5000);
    carousel.addEventListener('mouseenter', () => clearInterval(timer));
    carousel.addEventListener('mouseleave', () => {
      timer = setInterval(() => goTo(current + 1), 5000);
    });

    // ---- Swipe left/right to change testimonials ----
    let touchStartX = 0;
    let touchStartY = 0;

    carousel.addEventListener(
      'touchstart',
      (e) => {
        const t = e.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
        clearInterval(timer); // pause auto-advance while the person is interacting
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchend',
      (e) => {
        const t = e.changedTouches[0];
        const dx = t.clientX - touchStartX;
        const dy = t.clientY - touchStartY;

        const SWIPE_THRESHOLD = 40;
        if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dx) >= Math.abs(dy)) {
          goTo(dx < 0 ? current + 1 : current - 1); // swipe left -> next, right -> prev
        }

        timer = setInterval(() => goTo(current + 1), 5000); // resume auto-advance
      },
      { passive: true }
    );
  }

  /* ---------------- BUY IT NOW ---------------- */
  function initBuyNow(root) {
    const btn = root.querySelector('[data-buy-now]');
    const form = root.querySelector('#tj-product-form, [id^="tj-product-form"]');
    if (!btn || !form) return;

    btn.addEventListener('click', () => {
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((r) => r.json())
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch((err) => console.error('Buy Now failed:', err));
    });
  }

  /* ---------------- DELIVERY TIMELINE DATES ---------------- */
  function initTimeline(root) {
    const dateEls = root.querySelectorAll('.tj-timeline-date');
    dateEls.forEach((el) => {
      const fmt = (d) =>
        d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });

      if (el.dataset.offsetDays !== undefined) {
        const d = new Date();
        d.setDate(d.getDate() + Number(el.dataset.offsetDays));
        el.textContent = fmt(d);
      } else if (el.dataset.offsetStart !== undefined) {
        const start = new Date();
        start.setDate(start.getDate() + Number(el.dataset.offsetStart));
        const end = new Date();
        end.setDate(end.getDate() + Number(el.dataset.offsetEnd));
        el.textContent = `${fmt(start)} - ${fmt(end)}`;
      }
    });
  }

  /* ---------------- STICKY BOTTOM BUY BAR ----------------
     Shows once the main buy box (title/price/add-to-cart)
     has scrolled out of the viewport — this is the
     "sticky after end of first section" behaviour requested. */
  function initStickyBar(root) {
    const buyBox = root.querySelector('[id^="tj-buy-box-"]');
    const bar = root.querySelector('[id^="tj-sticky-bar-"]');
    if (!buyBox || !bar) return;

    bar.hidden = false; // present in DOM, CSS controls visibility via transform

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );
    observer.observe(buyBox);

    const stickyAddBtn = bar.querySelector('[data-sticky-add]');
    const mainForm = root.querySelector('#tj-product-form, [id^="tj-product-form"]');
    if (stickyAddBtn && mainForm) {
      stickyAddBtn.addEventListener('click', () => {
        mainForm.requestSubmit
          ? mainForm.requestSubmit()
          : mainForm.submit();
      });
    }
  }
})();